export default "__VITE_ASSET__B2yu228G__"